import { Injectable, Provider, Type } from '@angular/core';
import { Subject } from 'rxjs';

export function provideSiteNavigationIntl(intl: Type<SiteNavigationIntl>): Provider {
  return {
    provide: SiteNavigationIntl,
    useClass: intl,
  }
}

@Injectable({providedIn: 'root'})
export class SiteNavigationIntl {

  public readonly changes$ = new Subject<void>();

  public overviewMenuEntryPrefix = 'Go to';

  public breadcrumbHomeLabel = 'Home';

  public openNavigationButtonLabel = 'Open navigation';

}
